'use client';

import { Description, RadioGroup, RadioGroupProps } from '@headlessui/react';
import { ReactNode, Ref, useEffect, useState } from 'react';

import { styles } from './UiKitRadioGroup.styles';

export type RadioGroupBase = Omit<RadioGroupProps, 'disabled'>;

export interface UiKitRadioGroupProps extends RadioGroupBase {
  children: ReactNode;
  className?: string;
  classNameInner?: string;
  value?: string;
  onChange?: (value: string) => void;
  ref?: Ref<HTMLDivElement>;
  error?: boolean;
  helperText?: string;
}

export function UiKitRadioGroup({
  children,
  className,
  classNameInner,
  ref,
  onChange,
  value: initialValue = '',
  error,
  helperText,
  ...props
}: UiKitRadioGroupProps) {
  const slots = styles({ error });

  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleChange = (value: string) => {
    setValue(value);
    onChange?.(value);
  };

  return (
    <RadioGroup
      className={className}
      {...props}
      value={value}
      onChange={handleChange}
    >
      <div
        ref={ref}
        className={slots.base({ className: classNameInner })}
      >
        {children}
      </div>
      {helperText && (
        <Description
          as="div"
          className={slots.helperText()}
        >
          {helperText}
        </Description>
      )}
    </RadioGroup>
  );
}
